export const NAME = "choose-contract-for-change";

export const FORM_CHOOSE_CONTRACT_FOR_CHANGE = "${NAME}/FORM_CHOOSE_CONTRACT_FOR_CHANGE";

export const FIELD_CONTRACT_TO_EDIT = "contractToEdit";
